<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="开票主体"
        prop="invoice_entity"
        :rules="[
          { required: true, message: '请输入开票主体', trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.invoice_entity"></el-input>
      </el-form-item>
      <el-form-item
        label="开票种类"
        prop="invoice_type"
        :rules="[
          { required: true, message: '请选择开票种类', trigger: 'blur' },
        ]"
      >
        <el-radio-group v-model="state.model.invoice_type">
          <el-radio
            :value="item.Key"
            v-for="item in $base.Invoice_Type"
            :key="item"
          >
            {{ item.Text }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="开票金额"
        prop="amount"
        :rules="[
          { required: true, message: '请输入开票金额', trigger: 'blur' },
        ]"
      >
        <el-input-number
          v-model="state.model.amount"
          :precision="2"
          class="number-input-left number-input-suffix"
          @focus="$onFocus"
          suffix="元"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="总经理审批"
        prop="ceo"
        :rules="[
          {
            required: true,
            message: '请选择总经理审批人',
            trigger: 'blur',
          },
        ]"
      >
        <c_userselect v-model="state.model.ceo" :type="3" />
      </el-form-item>
      <ul class="font-bold text-sm flex items-center gap-x-1 mt-3 mb-2">
        <li
          style="
            width: 3px;
            background-color: var(--el-color-primary);
            height: 12px;
            border-radius: 10px;
          "
        >
          &nbsp;
        </li>
        开票信息
      </ul>
      <el-form-item
        label="发票抬头"
        prop="invoice_title"
        :rules="[
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.invoice_title"></el-input>
      </el-form-item>
      <el-form-item
        label="纳税人识别号"
        prop="tax_no"
        :rules="[
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.tax_no"></el-input>
      </el-form-item>
      <el-form-item label="单位地址">
        <el-input v-model="state.model.address"></el-input>
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input v-model="state.model.phone"></el-input>
      </el-form-item>
      <el-form-item label="开户银行">
        <el-input v-model="state.model.opening_bank"></el-input>
      </el-form-item>
      <el-form-item label="银行账户">
        <el-input v-model="state.model.bank_account"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="state.model.remark"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_invoice_add } from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number, //会议Id
    meeting_bill_title: String, //会议单据抬头，默认为开票主体
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.model.meeting_id = props.meeting_id;
      state.model.invoice_entity = props.meeting_bill_title;
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          meeting_invoice_add(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
